/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';

class MessageHistoryDialog extends React.Component {
  render() {
    const titleText = 'Participants in this class can see all announcements 🎉';

    const title = (
      <TextWithEntities
        text={titleText}
        entities={TextEntities.parseEmoji(titleText)}
      />
    );

    return (
      <ConfirmDialog
        eventScreenName="MessageHistoryDialog"
        {...this.props}
        title={title}
        subtext={`People in your new class will be able to read every
          announcement you send—no matter when they join. Allow this for
          all of your classes?`}
        actionButtonText="Allow"
        cancelButtonText="Cancel"
      />
    );
  }
}

export default MessageHistoryDialog;



// WEBPACK FOOTER //
// ./src/user/components/MessageHistoryDialog.jsx